// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__AtgrH","card":"styles_card__c5KVH","pulse":"styles_pulse__4g_K_","jump":"styles_jump__GVYEa"};